import { useCategory } from "../../../fetch/fetch.category.ts";
import { EMPTY_CATEGORY } from "../../../const/typeDefault/Category.ts";

const CategoryTitle = ({ slug }: { slug: string }) => {
  const { category, isLoading, isError } = useCategory(slug, EMPTY_CATEGORY);
  if (isLoading) {
    return "Kategorie";
  }
  if (isError) return isError;
  return category.name;
};
export default CategoryTitle;
